import { useState, useEffect } from "react";
import useSWR from "swr";
import { formatUnixInAppTz } from "../utils/datetime";

type FetchData = { [key: string]: { [timestamp: string]: number } };

const useMonthlyCarbonFootprint = (monthBackward: number,enableOccupancy?:boolean) => {
  const [monthlyCarbonFootprint, setMonthlyCarbonFootprint] = useState<
    | {
        [key: string]: {
          data: { key: string; value: number; label: string }[];
        };
      }
    | undefined
  >(undefined);

  const { data } = useSWR<FetchData>([
    "v1/thaihealth/graph_data/monthly_carbon_footprint/",
    { month_backward: monthBackward, enable_occupancy: enableOccupancy },
  ]);
  useEffect(() => {
    if (data) {
      const transformedData = transformData(data);
      setMonthlyCarbonFootprint(transformedData);
    }
  }, [data]);

  const transformData = (
    data: FetchData
  ): {
    [key: string]: { data: { key: string; value: number; label: string }[] };
  } => {
    const transformedData = Object.keys(data).reduce(
      (
        acc: {
          [key: string]: {
            data: { key: string; value: number; label: string }[];
          };
        },
        category
      ) => {
        acc[category] = {
          data: Object.keys(data[category]).map((timestamp) => ({
            key: formatUnixInAppTz(parseInt(timestamp), "MMM"),
            value: data[category][timestamp],
            label: formatUnixInAppTz(parseInt(timestamp), "MMMM"),
          })),
        };
        return acc;
      },
      {}
    );
    return transformedData;
  };

  return { data: monthlyCarbonFootprint };
};

export default useMonthlyCarbonFootprint;
